import React from "react";

import { Hero } from "../Hero";
import { Banner } from "@/components/Banner";
import { BannerWrapperSize } from "@/components/Banner/types";
import { billboardProps } from "@/data/types/home";

export const HeroModule = ({
  data,
  wrapperSize,
}: {
  data: billboardProps;
  wrapperSize: BannerWrapperSize;
}) => {
  const { ctaLabel, ctaLink, richtext, data_qa, backgroundColor, ctaStyle, twoColumns } = data;

  return (
    <Banner
      medium
      light
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}>
      <Hero
        priority
        heroText={richtext}
        cta={{
          ctaLink,
          ctaLabel,
          data_qa,
          ctaStyle,
        }}
        twoColumns={twoColumns}
        img={"/images/hero-banner.png"}
      />
    </Banner>
  );
};
